import Grid from '@material-ui/core/Grid';
import { AssetImage } from 'assets/Asset';
import React, { memo } from 'react';

const DooPageWrapper = memo(({ children }) => {
  if (window.innerWidth >= 1000)
    return (
      <div className="flex-center-row" style={{ height: '100%' }}>
        <img
          src={AssetImage.DooPageLogin}
          alt="img"
          style={{
            height: '120%',
            position: 'absolute',
            right: -100,
            top: -50,
            opacity: 0.3,
          }}
        />
        <Grid
          container
          style={{
            height: '80%',
            backgroundColor: '#fff',
            color: '#000',
            width: '85%',
            boxShadow: '0px 10px 80px rgba(0,0,0,0.6)',
            overflow: 'hidden',
            borderRadius: 10,
          }}>
          <Grid item xs={6} className="flex-center-col" style={{ backgroundColor: '#fff' }}>
            {children}
          </Grid>
          <Grid item xs={6} style={{ backgroundColor: '#ec971f' }} className="flex-center-col">
            <img
              src={AssetImage.DooPageLogin}
              alt="img"
              style={{ width: '100%', height: '100%' }}
            />
          </Grid>
        </Grid>
      </div>
    );

  return <div className="flex-center-col flex-full">{children}</div>;
});

export default DooPageWrapper;
